import request from '../utils/request'
export const webIfon = params => request({
  url: '/api/users/webInfo',
  params
}) 